<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('question_procedure') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <!-- Question Procedure Header -->
                    <div class="grid">
                        <div class="col-12">
                            <div class="field grid">
                                <label for="Fortable" class="col-1">{{ $t('fortable') }}<span style="color: red;">*</span></label>
                                <div class="col-5">
                                    <Dropdown name="Fortable" v-model="header.Fortable" :options="fortableOptions" 
                                        optionLabel="label" optionValue="value" :placeholder="$t('select_for_table')"
                                        v-if="header" :class="{ 'p-invalid': submitted && !header.Fortable }"
                                        :disabled="true" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Fortable && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('for_table')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Col_Area" class="col-1">{{ $t('col_area') }}<span style="color: red;">*</span></label>
                                <div class="col-1">
                                    <InputText name="Col_Area" v-model="header.Col_Area" type="text" 
                                        :placeholder="$t('col_area')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Col_Area }"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Col_Area && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('col_area')) }}
                                    </small>
                                </div>
                                <label for="Point" class="col-1">{{ $t('point') }}</label>
                                <div class="col-1">
                                    <InputNumber name="Point" v-model="header.Point" :placeholder="$t('point')"
                                        v-if="header" :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW" />
                                    <Skeleton v-else-if="!header" />
                                </div>
                                <label for="Loop_Total" class="col-1">{{ $t('loop_total') }}</label>
                                <div class="col-1">
                                    <InputNumber name="Loop_Total" v-model="header.Loop_Total" :placeholder="$t('loop_total')"
                                        v-if="header" :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW" />
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Question_Eng" class="col-1">{{ $t('question_eng') }}<span style="color: red;">*</span></label>
                                <div class="col-5">
                                    <Textarea name="Question_Eng" v-model="header.Question_Eng" rows="3"
                                        :placeholder="$t('question_eng')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Question_Eng }"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Question_Eng && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('question_eng')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Question_Ind" class="col-1">{{ $t('question_ind') }}<span style="color: red;">*</span></label>
                                <div class="col-5">
                                    <Textarea name="Question_Ind" v-model="header.Question_Ind" rows="3"
                                        :placeholder="$t('question_ind')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Question_Ind }"
                                        :disabled="mode == this.$FORM_MODE_DELETE || mode == this.$FORM_MODE_VIEW" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Question_Ind && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('question_ind')) }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Questions Section -->
                    <div class="grid" v-if="header && header.Questions">
                        <div class="col-12">
                            <Card>
                                <template #title>
                                    <div class="flex align-items-center gap-2">
                                        <span>{{ $t('questions') }}</span> &nbsp;
                                        <Button icon="pi pi-plus" class="p-button-rounded p-button-outlined p-button-sm"
                                            @click="addQuestion" :title="$t('add_question')"
                                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                                    </div>
                                </template>
                                <template #content>
                                    <DataTable :value="header.Questions" editMode="cell" @cell-edit-complete="onQuestionCellEditComplete"
                                        class="p-datatable-sm" :rowClass="hideRow" showGridlines responsiveLayout="scroll">
                                        <Column field="Col_Area" :header="$t('col_area')" style="width: 10%">
                                            <template #body="{ data, index }">
                                                <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Col_Area }}</span>
                                                <InputText v-else v-model="data.Col_Area" class="p-inputtext-sm" @input="editQuestionByIndex(index)" />
                                            </template>
                                        </Column>
                                        <Column field="Question_Eng" :header="$t('question_eng')" style="width: 25%">
                                            <template #body="{ data, index }">
                                                <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Question_Eng }}</span>
                                                <Textarea v-else v-model="data.Question_Eng" rows="2" class="p-inputtext-sm" @input="editQuestionByIndex(index)" />
                                            </template>
                                        </Column>
                                        <Column field="Question_Ind" :header="$t('question_ind')" style="width: 25%">
                                            <template #body="{ data, index }">
                                                <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Question_Ind }}</span>
                                                <Textarea v-else v-model="data.Question_Ind" rows="2" class="p-inputtext-sm" @input="editQuestionByIndex(index)" />
                                            </template>
                                        </Column>
                                        <Column field="Point" :header="$t('point')" style="width: 10%">
                                            <template #body="{ data, index }">
                                                <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Point }}</span>
                                                <InputNumber v-else v-model="data.Point" class="p-inputtext-sm" @input="editQuestionByIndex(index)" />
                                            </template>
                                        </Column>
                                        <Column :header="$t('actions')" style="width: 15%">
                                            <template #body="slotProps">
                                                <Button icon="pi pi-list" class="p-button-sm p-button-outlined mr-2"
                                                    @click="toggleQuestionDetails(slotProps.index)" :title="$t('question_details')" />
                                                <Button icon="pi pi-trash" class="p-button-sm p-button-danger p-button-outlined"
                                                    @click="deleteQuestion(slotProps)" :title="$t('delete')"
                                                    v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                                            </template>
                                        </Column>
                                    </DataTable>

                                    <!-- Question Details - Show below main table when expanded -->
                                    <div v-for="(question, questionIndex) in header.Questions" :key="question.Id" class="mt-3">
                                        <Card v-if="expandedRows[question.Id]">
                                            <template #title>
                                                <div class="flex align-items-center gap-2">
                                                    <span>{{ $t('question_details') }} - {{ question.Col_Area }}</span> &nbsp;
                                                    <Button icon="pi pi-plus" class="p-button-rounded p-button-outlined p-button-sm"
                                                        @click="addQuestionDetail(questionIndex)" :title="$t('add_detail')"
                                                        v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                                                </div>
                                            </template>
                                            <template #content>
                                                <DataTable :value="question.Details" editMode="cell"
                                                    @cell-edit-complete="onDetailCellEditComplete"
                                                    class="p-datatable-sm" :rowClass="hideRow" showGridlines>
                                                    <Column field="Question_Eng" :header="$t('question_eng')" style="width: 40%">
                                                        <template #body="{ data, index }">
                                                            <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Question_Eng }}</span>
                                                            <Textarea v-else v-model="data.Question_Eng" rows="2" class="p-inputtext-sm" 
                                                                @input="editQuestionDetailByIndex(questionIndex, index)" />
                                                        </template>
                                                    </Column>
                                                    <Column field="Question_Ind" :header="$t('question_ind')" style="width: 40%">
                                                        <template #body="{ data, index }">
                                                            <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Question_Ind }}</span>
                                                            <Textarea v-else v-model="data.Question_Ind" rows="2" class="p-inputtext-sm" 
                                                                @input="editQuestionDetailByIndex(questionIndex, index)" />
                                                        </template>
                                                    </Column>
                                                    <Column field="Point" :header="$t('point')" style="width: 10%">
                                                        <template #body="{ data, index }">
                                                            <span v-if="mode == this.$FORM_MODE_VIEW || mode == this.$FORM_MODE_DELETE">{{ data.Point }}</span>
                                                            <InputNumber v-else v-model="data.Point" class="p-inputtext-sm" 
                                                                @input="editQuestionDetailByIndex(questionIndex, index)" />
                                                        </template>
                                                    </Column>
                                                    <Column :header="$t('actions')" style="width: 10%">
                                                        <template #body="detailSlotProps">
                                                            <Button icon="pi pi-trash" class="p-button-sm p-button-danger p-button-outlined"
                                                                @click="deleteQuestionDetail(questionIndex, detailSlotProps)"
                                                                v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                            </template>
                                        </Card>
                                    </div>
                                </template>
                            </Card>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>

<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "QuestionIndex",
            url: this.$API_URL + "question/",
            header: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            expandedRows: {},
            fortableOptions: [
                { label: 'FIRSTLINE', value: 'FIRSTLINE' },
                { label: 'MANAGERIAL', value: 'MANAGERIAL' },
                { label: 'NONSTAFF', value: 'NONSTAFF' },
                { label: 'STAFF', value: 'STAFF' }                                
            ],
            newQuestion: {
                Id: 0,
                Col_Area: '',
                Question_Eng: '',
                Question_Ind: '',
                Point: 0,
                Fortable: '',
                Answer: '',
                Action_Role: '',
                Employee_Id: 0,
                mode: this.$FORM_MODE_CREATE,
                Details: []
            },
            newQuestionDetail: {
                Id: 0,
                Question_Id: 0,
                Question_Eng: '',
                Question_Ind: '',
                Point: 0,
                mode: this.$FORM_MODE_CREATE
            }
        }
    },
    methods: {
        getData() {
            var self = this;
            this.expandedRows = {};
            
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    if (response.data.success) {
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                                                
                        if (!self.header.Questions) {
                            self.header.Questions = [];
                        }
                        
                        self.header.Questions.forEach((question, index) => {
                            console.log(`Question ${index}:`, question);
                            if (!question.Details) {
                                question.Details = [];
                            }
                            question.mode = self.$FORM_MODE_UNCHANGED;
                            question.Details.forEach(detail => {
                                detail.mode = self.$FORM_MODE_UNCHANGED;
                            });
                        });                        
                    } else {
                        console.error('API Error:', response.data.message);
                        self.showError('Error Loading Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching data:', error);
                    self.showError('Error Loading Data', error.message || error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
                        
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ 
                                name: self.indexName, 
                                params: { 
                                    showToast: true, 
                                    severity: 'success', 
                                    summary: 'Data Deleted', 
                                    detail: "Question Procedure " + self.header.Col_Area + " has been deleted successfully", 
                                    life: 3000 
                                } 
                            });
                        } else {
                            self.$router.push({ 
                                name: self.indexName, 
                                params: { 
                                    showToast: true, 
                                    severity: 'success', 
                                    summary: 'Data Saved', 
                                    detail: "Question Procedure " + self.header.Col_Area + " has been saved successfully", 
                                    life: 3000 
                                } 
                            });
                        }
                    } else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    console.error('Save error:', error);
                    self.showError('Error Saving Data', error.response?.data?.message || error.message || error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Question/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            if (!this.header.Col_Area || !this.header.Question_Eng || !this.header.Question_Ind || !this.header.Fortable) {
                return;
            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        // Do nothing
                    }
                });
            }
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addQuestion() {
            var newQuestion = { ...this.newQuestion };
            newQuestion.Id = Date.now(); 
            newQuestion.Fortable = this.header.Fortable;
            newQuestion.Col_Area = this.header.Col_Area;
            newQuestion.Details = [];
            this.header.Questions.push(newQuestion);            
        },
        deleteQuestion(event) {
            if (event) {
                var question = this.header.Questions[event.index];
                if (question.mode == this.$FORM_MODE_CREATE) {
                    this.header.Questions.splice(event.index, 1);
                } else {
                    question.mode = this.$FORM_MODE_DELETE;
                }
            }
        },
        onQuestionCellEditComplete(event) {
            this.editQuestion(event.index);
        },
        editQuestion(indexOrEvent) {
            let index = typeof indexOrEvent === 'number' ? indexOrEvent : null;
            
            if (index === null && indexOrEvent && indexOrEvent.target) {
                return;
            }
            
            if (this.header && this.header.Questions && this.header.Questions[index]) {
                let mode = this.header.Questions[index].mode;
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Questions[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        
        toggleQuestionDetails(index) {
            const questionId = this.header.Questions[index].Id;
            if (this.expandedRows[questionId]) {
                delete this.expandedRows[questionId];
            } else {
                this.expandedRows[questionId] = true;
            }
        },
        addQuestionDetail(questionIndex) {
            var newDetail = { ...this.newQuestionDetail };
            newDetail.Id = Date.now();
            newDetail.Question_Id = this.header.Questions[questionIndex].Id;
            this.header.Questions[questionIndex].Details.push(newDetail);
        },
        deleteQuestionDetail(questionIndex, detailEvent) {
            if (detailEvent) {
                var detail = this.header.Questions[questionIndex].Details[detailEvent.index];
                if (detail.mode == this.$FORM_MODE_CREATE) {
                    this.header.Questions[questionIndex].Details.splice(detailEvent.index, 1);
                } else {
                    detail.mode = this.$FORM_MODE_DELETE;
                }
            }
        },
        onDetailCellEditComplete(event) {
            for (let i = 0; i < this.header.Questions.length; i++) {
                if (this.header.Questions[i].Details.includes(event.data)) {
                    this.editQuestionDetail(i, event.index);
                    break;
                }
            }
        },
        editQuestionDetail(questionIndex, detailIndex) {
            if (this.header && this.header.Questions[questionIndex] && this.header.Questions[questionIndex].Details) {
                let mode = this.header.Questions[questionIndex].Details[detailIndex].mode;
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Questions[questionIndex].Details[detailIndex].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        editQuestionByIndex(index) {
            console.log('Editing question at index:', index);
            if (this.header && this.header.Questions && this.header.Questions[index]) {
                let mode = this.header.Questions[index].mode;
                console.log('Current mode:', mode);
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Questions[index].mode = this.$FORM_MODE_EDIT;
                    console.log('Changed mode to EDIT for question:', index);
                }
            }
        },
        editQuestionDetailByIndex(questionIndex, detailIndex) {
            console.log('Editing question detail:', questionIndex, '-', detailIndex);
            if (this.header && this.header.Questions[questionIndex] && this.header.Questions[questionIndex].Details) {
                let mode = this.header.Questions[questionIndex].Details[detailIndex].mode;
                console.log('Current detail mode:', mode);
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Questions[questionIndex].Details[detailIndex].mode = this.$FORM_MODE_EDIT;
                    console.log('Changed detail mode to EDIT for:', questionIndex, '-', detailIndex);
                }
            }
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        
        if (this.mode == this.$FORM_MODE_CREATE) {
            this.header = {
                Id: 0,
                Col_Area: '',
                Question_Eng: '',
                Question_Ind: '',
                Point: 0,
                Loop_Total: 0,
                Fortable: '',
                Sub_Rating: 0,
                Sub_Score: 0,
                mode: this.mode,
                Questions: []
            };
        } else {
            this.getData();
        }
    }
}
</script>

<style scoped>
.row-hidden {
    opacity: 0.5;
    text-decoration: line-through;
}
</style>